// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---o9O7N","sk-bouncedelay":"sk-bouncedelay---mx40I","bounce1":"bounce1---VeMA8","bounce2":"bounce2---SIRuk"};